import "./lib/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import Clarity from "@microsoft/clarity";

import { routeTree } from "./routeTree.gen";

const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
  interface HistoryState {
    hideCancelButton?: true;
    fromPrevious?: true;
    withSuccessNotification?: true;
    formData?: Record<string, any>;
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

window.addEventListener(
  "CookieInformationConsentGiven",
  () => {
    if (window.CookieInformation?.getConsentGivenFor("cookie_cat_statistic")) {
      Clarity.init(clarityProjectId);
      Clarity.consentV2();
    }
  },
  { capture: false, once: true },
);
